import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ViWizard from 'scoreboard/imports/vi/vi-wizard'
import Import from 'scoreboard/imports/model/import'
import AdminPanels from '../admin-panels'
import importsRow from './imports-row.hbs'
import importsRowDetail from './import-row-detail.hbs'
import importDataSourceInfo from './import-datasource-info.hbs'
import importStatus from './import-status'
import momentHelper from 'scoreboard/components/moment-helper'
import viDialog from 'scoreboard/imports/vi/vi-dialog'
import ViTransformations from 'scoreboard/imports/vi/vi-transformations'
import DataSourceInfoWizard from 'scoreboard/imports/data-source-info-wizard'
import MappingsWizard from 'scoreboard/imports/vi/mappings-wizard'
import LabelOwnersSchedule, { LABEL, LABEL_AND_OWNERS, SCHEDULE, OWNERS } from 'scoreboard/imports/label-owners-schedule'
import DatasetConnectionRow from 'scoreboard/datasets/dataset-connection-row'
import adminPanel from '../admin-panel.hbs'
import Dataset from 'scoreboard/datasets/model/dataset'
import appDisplay from 'scoreboard/components/app-display'
import ImportResults from 'scoreboard/components/import-results-dialog'
import UploadSpreadsheet from 'scoreboard/imports/upload-spreadsheet'
import conductor from 'scoreboard/components/conductor'
import ImportExportFilterPanel from './import-export-filter-panel'
import scrollContainer from 'scoreboard/components/scroll-container'
import enums from 'scoreboard/components/enums'
import {downloadFromUrl} from 'scoreboard/components/files/file'
import ErrorView from 'scoreboard/components/error-view'
import RefreshButton from 'scoreboard/components/refresh-button'
import license from 'scoreboard/components/license'
import projects from 'scoreboard/projects/projects'
import Tooltip from 'scoreboard/components/tooltip'
import principal from 'scoreboard/components/principals'
import Immutable from 'immutable'
const Set = Immutable.Set
import permissions from 'scoreboard/components/permissions'
import highlight from 'scoreboard/components/highlight'
import { MAX_RESULTS } from 'scoreboard/admin/imports/import-export-filter-panel'
import unwrapModel from 'scoreboard/components/unwrap-model'
import RestCommunicationDetails from 'scoreboard/imports/rest/rest-communication-details'
import Importable from 'scoreboard/imports/model/importable'

let statusAndConnectionFilterOptions = _.memoize(function() {
	let statuses =_.map(enums.toOptionData('importStatus'), item =>
		_.extend(item, {type:'status', group:i18n.get('admin.import.status')}))
	let connections = _.map(enums.toOptionData('importConnectionType'), item =>
		_.extend(item, {type:'connection', group:i18n.get('admin.importConnections')}))
	return [...statuses, ...connections]
})

var Imports = AdminPanels.extend({

	heading: 'admin.import.valueImports',
	titleDescKeyPrefix: 'admin.import.scheduled.',
	tooManyResultsKey: 'admin.import.tooManyResults',
	addButtonLabel: 'admin.databaseConnections.action.add',

	rowTemplate: (rowContext, includeDetail = false) => {
		let additionalInfo = ''
		if (includeDetail) {
			let dataSourceInfo = importDataSourceInfo(rowContext)
			additionalInfo = importsRowDetail(_.extend({}, rowContext, {dataSourceInfo}))
		}

		return importsRow(_.extend({}, rowContext, {additionalInfo}))
	},
	Model: Import,
	className: AdminPanels.prototype.className + ' imports',

	events: _.extend({}, AdminPanels.prototype.events, {
		'click .panel:not([data-type=dataset]) .run': 'onRun',
		'click .panel:not([data-type=dataset]) .upload': 'onUpload',
		'click .panel:not([data-type=dataset]) .download': 'onDownload',
		'click .panel:not([data-type=dataset]) .data-source-info .edit': 'onEditDataSourceInfo',
		'click .panel:not([data-type=dataset]) .transformations .edit': 'onEditTransformations',
		'click .panel:not([data-type=dataset]) .mappings .edit': 'onEditMappings',
		'click .panel:not([data-type=dataset]) .schedule .edit': 'onEditSchedule',
		'click .panel:not([data-type=dataset]) .label .edit': 'onEditLabel',
		'click .panel:not([data-type=dataset]) .owners .edit': 'onEditOwners',
		'click .panel:not([data-type=dataset]) .details': 'details'
	}),

	/**
	 * The Admin | Scheduled Imports screen
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Array} options.collection the imports to display
	 *
	 * @param {Array} options.datasets the datasets to display
	 *
	 * @param {Number} [options.id] ID of an import to pre-select
	 *
	 * @param {String} [options.type] the type of import to pre-select. Needs to
	 * be specified for any records not from the imports table (i.e. datasets)
	 */
	initialize: function(options = {}) {
		AdminPanels.prototype.initialize.apply(this, arguments)
		this.listenTo(importStatus, 'change',
			({id, lastImportStatus, running, importResults, resultsSummary}) => {
			// #35820 update the item with this id only in the imports panels
			// (not datasets panel)
			let itemEl = this.$(`.panel:not([data-type="dataset"]) [data-id=${id}]`)
			if (lastImportStatus && lastImportStatus !== 'running') {
					itemEl
					.removeClass('failed partial-success success cancelled interrupted')
					.addClass(lastImportStatus)
				// update item
				let item = this._item(id)
				if (!_.isNil(item)) {
					item.importResults = importResults
					item.lastImportStatus = lastImportStatus
					item.running = running
					item.resultsSummary = resultsSummary
					let html = this.rowTemplate(this.rowContext(item), true)
					itemEl.replaceWith(html)
					let refreshButton = this.showLoading(id)

					if (!running) {
						// Give the button a split second before marking it done
						// so that the checkmark animation can play properly
						// and not get stuck (since we just created the button).
						setTimeout(() => refreshButton.done(), 100)
					}
				}
			}
		})

		//setup filter panel
		this.filterPanel = new ImportExportFilterPanel({
			filterTypes: ['user','group','label','status','connection', 'importConnectionType'],
			filters: [...statusAndConnectionFilterOptions()],
			owningPrinciples: this._getAllOwningPrinciples(),
			importOrExportIdFromUrl: Number(this.options.id)
		})
		this.importById = _.keyBy(this.collection, 'id')
		this.listenTo(this.filterPanel, 'matches', ids => this._filterSelected(ids))
		this.on('resize', () => _.invoke(this.filterPanel, 'resize'))
	},

	showLoading(id) {
		let target = this.$(`[data-id=${id}] .refresh-button`)
		let refreshButton = new RefreshButton({
			el: target,
			actionsContainer: target.closest('.actions-container')
		})
		refreshButton.loading()
		return refreshButton
	},

	// #30867 get all principals that own any import(s) - either directly or indirectly
	_getAllOwningPrinciples: function() {
		return _.chain(this.collection)
			.map(it => [it.owners, it.indirectOwners, it.usersFromGroups])
			.flattenDeep()
			.compact()
			.uniqBy(it => principal.hashCode(it))
			.value()
	},

	_renderFilteredPanels: function(matchedIds) {
		this.renderPanel('metric-value', matchedIds, {add: permissions.importMetricValues()})
		this.renderPanel('initiative-status', matchedIds,
			{add: permissions.anyUpdateInitiativeStatus()})
	},

	_applyItemSelectionFromPath: _.once(function() {
		// highlight an import if desired
		if (this.options.id) {
			if (this.options.type === 'dataset') {
				this.toggleListItem({
					id: this.options.id,
					type: this.options.type
				})
			} else {
				let item = this._item(this.options.id)
				if (!_.isUndefined(item)) {
					this.toggleListItem(item)
				}
			}
			scrollContainer(this.el).scrollTop(this.scrollPosition)
			this.scrollPosition = undefined
		}
	}),

	render: function() {
		AdminPanels.prototype.render.apply(this, arguments)
		// eventually there will be panels for each ImportDataType
		this._renderFilteredPanels(Set())

		// #30463 only display datasets if datasets are enabled by license
		if (license.datasets) {
			this.renderDatasetsPanel()
		}

		this.filterPanel.clear()
		_.each(this.collection, imp => {
			let {id, label, lastImportStatus, dataSourceMetadata} = imp
			//setup the matching terms
			let matches = [
				{groupId: 'label', term: id},
				{groupId: 'connection', term: _.get(imp,'connection.id')}
			]
			_.each(imp.owners, principal =>  matches.push({groupId: principal.type, term:principal.id}))
			//add the filter label for this import
			let filters = []

			// Import Name
			filters.push({
				id,
				label,
				type:'label',
				group:i18n.get('admin.import.importName')
			})

			// Import Status
			if (lastImportStatus) {
				let statusMessageKey =
					`admin.import.status.${_.camelCase(lastImportStatus)}`
				let label = i18n.get(statusMessageKey)
				matches.push({groupId: 'status', term: lastImportStatus})
				filters.push({
					id: lastImportStatus,
					label,
					type: 'status',
					group: i18n.get('admin.import.status')
				})
			}

			// Import Connection Type
			if (dataSourceMetadata && dataSourceMetadata.source !== 'document') {
				let group = i18n.get('admin.import.importConnectionType')
				let term = this._getImportLabelFromMetaData(dataSourceMetadata)
				matches.push({groupId: 'importConnectionType', term})
				filters.push({
					id: term,
					label: term,
					type:'importConnectionType',
					group
				})
			}

			this.filterPanel.addItemFilter({
				id, filters, matches,
				indirectOwners: imp.indirectOwners,
				usersFromGroups: imp.usersFromGroups
			})
		})
		scrollContainer(this.el).prepend(this.filterPanel.el)
		this.filterPanel.render()
		return this
	},


	_getImportLabelFromMetaData: function(dataSourceMetadata) {
		let source = dataSourceMetadata.spreadsheet ? 'spreadsheet' :
			dataSourceMetadata.source

		switch (source) {
			case 'spreadsheet':
				return i18n.get('documents.fileType.spreadsheet')
			case 'database':
				return i18n.get('common.database')
			default: return source
		}
	},

	_filterSelected: function(ids) {
		let panelTypes = ['dataset', 'initiative-status', 'metric-value']
		let noFilter = _.isNil(ids)

		this._renderFilteredPanels(ids)
		this._applyItemSelectionFromPath()

		// If there's no filter, make sure we use the regular css nth-child
		// list-striped styling.
		if (noFilter) {
			_.each(panelTypes, type => {
				this.$(`.panel[data-type="${type}"] .panel-content ul`)
					.addClass('list-striped')
					.find('.import-connection-row')
					.removeClass('list-striped-item')
			})
		}

		if (!noFilter) {
			_.each(panelTypes, type => {
				this.$(`.panel[data-type="${type}"] .panel-content ul`)
					.removeClass('list-striped')
					.find('.import-connection-row:not(.is-not-displayed)')
					// Add .list-striped-item for odd list items
					.each((i, row) => {
						this.$(row).toggleClass('list-striped-item', (i+1) % 2 == 1)
					})
			})
		}
	},

	renderPanel: function(type, matchedIds, permissions) {
		let filterPredicate = matchedIds ? it => matchedIds.has(it.id) : () => true
		let matchCount = _.sumBy(this.collection, filterPredicate)
		let panel
		if (matchCount > MAX_RESULTS) {
			panel = AdminPanels.prototype.renderEmptyPanel.apply(this, arguments)
			let emptyMessage = i18n.get(this.tooManyResultsKey, matchCount)
			panel.find('.panel-content').empty()
				.attr('data-empty-state-message', emptyMessage)
		} else {
			panel = AdminPanels.prototype.renderPanel.apply(this, [type, filterPredicate])
		}
		this.$('.add .label').text(i18n.get('admin.import.addImport'))
		if (!permissions.add) {
			this.$(`.panel[data-type="${type}"] .add`).addClass('is-not-displayed')
		}
		return panel
	},

	renderDatasetsPanel: function() {
		this.$('.panel:last').after(adminPanel({
			type: 'dataset',
			titleKey: 'datasets.datasets'
		}))
		let panel = this.$('.panel[data-type="dataset"]')
		let listEl = panel.find('.panel-content .list')

		let noDatasets = _.isEmpty(this.options.datasets)
		if (noDatasets) {
			panel.find('.panel-content').empty()
				.attr('data-empty-state-message', i18n.get(`datasets.noneScheduled`))
		}

		// render the list
		let datasets = _.sortBy(this.options.datasets, d => d.label.toLocaleLowerCase())
		_.each(datasets, dataset => {
			let row = new DatasetConnectionRow({ model: new Dataset(dataset) })
			listEl.append(row.el)
			row.render()
			row.$el
				.attr('data-id', dataset.id)
				.addClass('imports-row dataset-imports-row')
			this.secureDatasetRow(row)
		})

		// can't add datasets from this screen
		panel.find('.right-buttons .add').remove()

	},

	_getEmptyMessage: function(type) {
		if (type === 'dataset') {
			return i18n.get('datasets.noneScheduled')
		} else {
			return i18n.get(`admin.import.${_.camelCase(type)}.noneFound`)
		}
	},

	// hides any editing options based on dataset permissions (#29158)
	secureDatasetRow: function(row) {
		// #49753 use the DatasetConnectionRow's Dataset Model isEditable
		// function to determine if any editing options should be available
		let editable = row.model.isEditable()
		row.$el.toggleClass('is-hiding-buttons', !editable)
	},

	rowContext: function(item) {
		let numMappings = item.numMappings || _.size(_.get(item, 'destinationMappingData.sourceNameToDestinationIdMap'))
		let running = item.running
		if (_.get(importStatus.get(item.id), 'running')) {
			running = true
		}
		let icon = item.source === 'database' ? 'database' : 'docs-spreadsheet-mono'
		if (item.connectionId && item.source === 'spreadsheet') {
			icon = 'ftp'
		}
		if (item.source === 'rest') {
			icon = 'webservice'
		}

		let imp = _.extend({}, item, importStatus.get(item.id))
		// Import.java always returns an empty dataSourceMetadata, so we must
		// preserve the item's metadata #31605
		imp.dataSourceMetadata = _.get(item, 'dataSourceMetadata')
		let schedule = _.get(item, 'scheduleData.description') ||
			i18n.get('admin.import.scheduled.not')
		let lastImportTime = _.get(imp, 'lastImportTime')
		lastImportTime = lastImportTime ?
			momentHelper.formatDateTimeWithZone(lastImportTime) :
			i18n.get('alerts.never')
		// #32040 do not display results or counts if status is either null
		// or "Not Run"
		let status = _.get(imp, 'lastImportStatus')
		let results = !_.isNil(status) && status != 'not-run'
		let problems = _.get(imp, 'problems')
		// #25411 display error icon instead of results for imports that
		// threw an error
		let error = !_.isNil(this.getErrorResult(problems))
		let errorMessage = 'admin.import.lastRun.problem'

		let runnable = true // display of run icon
		let details = true // display of details button

		// #29594 if running the import resulted in no data to import, display
		// the error icon with a specific error message & hide the details button
		if (this.noData(imp)) {
			error = true
			errorMessage = 'admin.import.errors.noData'
			details = false // don't show details button
		}

		// #29375 if the import has no owners, it is not valid and cannot run
		// status will be 'failed', run button hidden,
		// and specific error message displayed without a details button
		let valid = !_.isNil(_.get(imp, 'owners'))
		if (!valid) {
			item.lastImportStatus = 'failed'
			results = true
			error = true
			errorMessage = 'admin.import.errors.noOwners'
			runnable = false
			details = false
		}

		// #29369 display adjustments for import results that were migrated
		// from Connect, which won't have success counts
		let displaySuccess = true
		let displaySkipped = true
		if (_.get(imp.importResults, 'migratedResults')) {
			// display the success span if status is 'success' (no count displayed)
			// or 'failure' - (displays 0)
			displaySuccess = status != 'partial-success'
			// do not display the skipped span for if status is 'success'
			displaySkipped = status != 'success'
		}

		let model = new Import(imp)

		// #49426 Zapier-specific tooltip for "Run Import" button
		let runImportTooltipDescription = this.buildRunImportTooltipDescription(model)

		return _.extend({}, item, {
			fileUpload: model.isFileUpload(),
			icon,
			running,
			numMappings,
			numTransformations: _.size(item.transformations),
			schedule,
			lastImportTime,
			owners: this.getOwnerHtml(item.owners),
			results,
			error,
			errorMessage,
			valid,
			displaySkipped,
			displaySuccess,
			runnable,
			details,
			runImportTooltipDescription,
			isDatabase: item.source === 'database',
			isRest: item.source === 'rest'
		})
	},

	/**
	 * Builds the description for the tooltip displayed when hovering over the
	 * "Run Import" button
	 */
	buildRunImportTooltipDescription: function(model) {
		let metadata = model.getDataSourceMetadata()
		// note that the metadata.label is not necessarily populated for db
		// value imports, so get the label from the connection if needed
		let label = metadata.label || _.get(model.attributes, 'connection.label')
		let description = i18n.get('admin.import.runImport.description', label)
		const zapierInfoMessage = i18n.get('datasets.dataSource.fetchNewData.zapierSuffix')
		if (metadata.source === 'zapier') {
			description += `<br><br>${zapierInfoMessage}`
		}
		return description
	},

	toggleItemElementExpanded: function(el) {
		AdminPanels.prototype.toggleItemElementExpanded.apply(this, arguments)
		if (el.hasClass('is-selected')) {
			let id = el.data('id')
			let importType = el.closest('[data-type]').data('type')
			// #32091 don’t apply import rowContext to dataset connections
			if (importType != 'dataset') {
				let item = [...(this.collection || [])]
					.find(it => it.type === importType && it.id === id)
				let context = this.rowContext(item)

				context.selected = true
				this.$(el).replaceWith(this.rowTemplate(context, true))

				const {connection} = context
				if (!_.isNil(connection)) {
					const {type: connectionType, status} = (connection || {})
					if (connectionType === 'database' && status === 'offline') {
						this.$(el).find('.additional-info .edit').addClass('is-disabled')
					}
				}
				// #57622 moved handling the the display of the full url endpoint
				// for REST imports (#53955) to import-datasource-info.hbs template
				// and preventing display of a download link for newly-added
				// database imports (#53989) to the rowContext to
				// prevent unwanted changes to other items when toggling the
				// expanded state of an import item
			}
		}
	},

	clickListItem: function(e) {
		// The following two lines need to run before the super method call because
		// otherwise the DOM elements they are harvesting data from will have been
		// destroyed
		let type = this.$(e.target).closest('[data-type]').data('type')
		let id = this._itemId(e)
		AdminPanels.prototype.clickListItem.apply(this, arguments)
		let url = `admin/imports/${id}`
		if (type === 'dataset') {
			url += '/dataset'
		}
		conductor.navigate(url)
	},

	// when the user clicks on add import
	add: function(e) {
		if (!projects.size()) {
			// #31262 Don't let users attempt to add imports if they aren't allowed
			// to view any organizations
			this.permissionsTooltip = new Tooltip({
				attachTo: $(e.currentTarget),
				content: i18n.get('common.security.noViewOrganizations'),
				placement: 'below',
				arrow: 'center'
			}).render()
			return
		}

		var type = $(e.target).closest('.panel').data('type')
		let wizard = ViWizard.start({
			type,
			doneKey: 'admin.import.run'
		})
		wizard.on('done', this._onAdd.bind(this))
	},

	edit: function(e) {
		let importId = this._itemId(e)
		// note: we need to retrieve the import so the column mappings are there
		// or there's a blowup on save
		const getImportOptions = {
			importId,
			definition:true,
			connection:false
		}
		viDialog(getImportOptions, data => {
			let model = new Import(data.import)
			let scheduleForm = new LabelOwnersSchedule({
				model,
				mode: LABEL_AND_OWNERS
			})
			scheduleForm.on('done', () => this._onEdit(model))
			// #31587 if a user removes them self as the import owner and no longer
			// has permission to view the edited import, remove the import from
			// their view
			scheduleForm.on('userRemoved', () => {
				this._removeItem()
			})
			return scheduleForm
		})
	},

	_onAdd: function(item) {
		AdminPanels.prototype._onAdd.apply(this, arguments)
		this._refreshImportOwners()
		this.toggleListItem(item)
	},

	 _onEdit: function(item) {
		 this.scrollPosition = scrollContainer(this.el).scrollTop()
		 AdminPanels.prototype._onEdit.apply(this, arguments)
		 this._refreshImportOwners()
		 this.toggleListItem(item)
	 },

	 _removeItem: function(id) {
		 AdminPanels.prototype._removeItem.apply(this, arguments)
		 this._refreshImportOwners()
	 },

	_refreshImportOwners: function() {
		this.filterPanel.options.owningPrinciples = this._getAllOwningPrinciples()
		this.render()
	},

	onRun: function(e) {
		let id = this._itemId(e)
		// if the import is already running, don't start running it again
		if (_.get(importStatus.get(id), 'running')) {
			return
		}
		let url = `api/imports/${id}/run`
		// #15026 initiative value imports
		let type = $(e.target).closest('.panel').data('type')
		if (type === 'initiative-status') {
			url = `api/imports/${id}/initiative-status/run`
		}
		// #33962 Ensure the loading icon starts as soon as the run button is clicked
		this.showLoading(id)
		$.post(url)
	},

	onUpload: function(e) {
		let importId = this._itemId(e)
		let instructions = i18n.get('admin.import.spreadsheet.upload.instructions')
		// #42188 only retrieve import definition when uploading a new spreadsheet,
		// and no example data, to allow the user to replace an invalid spreadsheet
		viDialog({importId, definition:true}, data => {
			let model = new Import(data.import)
			let uploadSpreadsheet = new UploadSpreadsheet({model, instructions})
			uploadSpreadsheet.on('done', metadata => {
				_.extend(model.getDataSourceMetadata(), metadata)
				let url = _.result(model, 'url') + '/clear'
				model.save({}, {
					url,
					success: () => {
						model.clearStatus()
						this._onEdit(model)
					}
				})
			})
			return uploadSpreadsheet
		})
	},

	onDownload: function(e) {
		downloadFromUrl(`imports/${this._itemId(e)}/spreadsheet`)
	},

	conditionalEdit(e, editOperation) {
		const action = $(e.target.closest('a.edit'))
		const importId = this._itemId(e)
		if (action.hasClass('is-disabled')) {
			this.disabledConnectionTooltip = new Tooltip({
				attachTo: $(e.currentTarget),
				content: i18n.get(`admin.import.databaseConnection.editNotAvailable`,
					highlight(_.get(this.importById[importId], 'connection.label'))),
				placement: 'below',
				arrow: 'center'
			}).render()
		} else {
			editOperation(importId)
		}
	},

	onEditDataSourceInfo: function(e) {
		this.conditionalEdit(e, importId => {
			// #35831 send parameter to indicate we are editing a datasource
			viDialog({importId, statuses: true, datasource: true}, data => {
				let model = new Import(data.import)
				let connections = data.connections
				let currentConnection = data.currentConnection
				let wizard = new DataSourceInfoWizard({model, connections, currentConnection})
				wizard.on('done', () => {
					model.clearStatus()
					this._onEdit(model)
				})
				return wizard._view()
			})
		})
	},

	onEditTransformations: function(e) {
		this.conditionalEdit(e, importId => {
			viDialog({importId}, data => {
				let model = new Import(data.import)
				let transformations = new ViTransformations({model})
				transformations.on('done', () => {
					model.clearStatus()
					this._onEdit(model)
				})
				return transformations
			})
		})
	},

	onEditMappings: function(e) {
		this.conditionalEdit(e, importId => {
			viDialog({importId, transform: true}, data => {
				let model = new Import(data.import)
				let wizard = new MappingsWizard({model})
				wizard.on('done', () => {
					model.clearStatus()
					this._onEdit(model)
				})
				return wizard._view()
			})
		})
	},

	onEditSchedule: function(e) {
		this.conditionalEdit(e, importId => {
			const xhrOptions = {
				importId,
				definition: true,
				// Prevents fetching the remote file; irrelevant for the schedule
				connection: false
			}

			viDialog(xhrOptions, data => {
				let model = new Import(data.import)
				let scheduleForm = new LabelOwnersSchedule({
					model,
					mode: SCHEDULE
				})
				scheduleForm.on('done', () => this._onEdit(model))
				return scheduleForm
			})
		})
	},

	onEditLabel: function(e) {
		const options = {
			importId: this._itemId(e),
			definition: true,
			connection: false
		}
		viDialog(options, data => {
			let model = new Import(data.import)
			let scheduleForm = new LabelOwnersSchedule({
				model,
				mode: LABEL
			})
			scheduleForm.on('done', () => this._onEdit(model))
			return scheduleForm
		})
	},

	onEditOwners: function(e) {
		const options = {
			importId: this._itemId(e),
			definition: true,
			connection: false
		}
		viDialog(options, data => {
			let model = new Import(data.import)
			let scheduleForm = new LabelOwnersSchedule({
				model,
				mode: OWNERS
			})
			scheduleForm.on('done', () => this._onEdit(model))
			// #31587 if a user removes them self as the import owner and no longer
			// has permission to view the edited import, remove the import from
			// their view
			scheduleForm.on('userRemoved', () => {
				this._removeItem()
			})
			return scheduleForm
		})
	},

	/**
	 * display ImportResults dialog
	 */
	details: function(e) {
		let id = this._itemId(e)
		let item = this._item(id)
		let results = _.get(item, 'importResults')
		let resultsDialog = new ImportResults({
			results,
			countMessageKey: 'admin.import.row'
		})
		let errorResult = this.getErrorResult(results.importProblems)
		if (!_.isNil(errorResult)) {
			// #56195 if the server returned invalid JSON, display communication
			// details
			if (errorResult.messageCode === 'admin.import.datasource.from.rest.2xx.notJson') {
				let xhr = $.post({
					url: 'api/imports/validate-rest-connection',
					data: JSON.stringify(item)
				})
				appDisplay.dialog(xhr, response => {
					let model = new Importable(_.defaults(response, item))
					return new RestCommunicationDetails({
						model,
						title: 'admin.import.errorView.title'
					})
				})
				return
			} else {
				// #25411 for imports that blew up, display
				// errorView with message and stacktrace
				resultsDialog = new ErrorView({
					message: errorResult.message,
					stackTrace: errorResult.stackTrace,
					title: 'admin.import.errorView.title'
				})
			}
		}
		appDisplay.dialog(resultsDialog)
	},

	getErrorResult: function(importProblems) {
		// if one of the import results contains a stacktrace
		// the import errored out
		let errorResult = _.find(importProblems, problem => {
			return !_.isNil(problem.stackTrace)
		})
		return errorResult
	},

	/**
	 * Determines if the importResults represent "no data was found"
	 * @param importResults
	 * @returns {boolean}
	 */
	noData: function (imp) {
		const unwrappedImport = unwrapModel(imp)
		const dataSourceMetadata = unwrappedImport.dataSourceMetadata
		if (!!dataSourceMetadata.lastFileEmpty) {
			return true
		}

		const importResults = _.get(imp, 'importResults')
		if (_.isNil(importResults)) {
			return false
		}
		let status = _.get(importResults, 'status')
		let problems = _.get(importResults, 'importProblems', [])
		let problemCount = _.size(problems)
		let skippedCount = _.get(importResults, 'skippedCount')
		let successCount = _.get(importResults, 'successCount')
		return status === 'failed' && problemCount == 1
			&& successCount == 0 && skippedCount == 0
			&& _.isNil(this.getErrorResult(problems))
	},

	remove: function() {
		AdminPanels.prototype.remove.apply(this, arguments)
		importStatus.unsubscribe()
		_.invokeMap([this.filterPanel, this.disabledConnectionTooltip,
			this.permissionsTooltip], 'remove')
	}

})

export default Imports
Imports.__filename__ = 'admin/imports/imports.js'
